export const title = 'Projects';
export const viewCode = 'View my code';
export const USERNAME = 'Smyrn96';
export const myRepo = 'https://github.com/smyrn96/';
